export default __webpack_public_path__ + "static/media/e3.5a49f2ee.png";